import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { merge, Observable, Subject } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigManagerService {

 private infiniteStream: Observable<any> = new Subject<void>().asObservable();
  private configuracoes!: Observable<any>;
  constructor(public http: HttpClient) {
    const params ={
      CertificationAuthorityName: 'SAFEWEB',
      EnvironmentName: this.obterAmbiente(),
      ApplicationName: environment.CONFIG_MANAGER.aplicacao,
      };
    this.configuracoes = merge(this
      .http
      .get<any>(environment.CONFIG_MANAGER.url, {
        params,
        headers: new HttpHeaders().set('Authorization', `basic ${environment.CONFIG_MANAGER.token}`),
       })
      ,
      this.infiniteStream).pipe(shareReplay(1));
  }

  obterConfigObservable(): Observable<any> {
    return this.configuracoes;
  }

  obterConfig(): any {
    let response;
    this.configuracoes.subscribe(resp => {
      if (resp) {
        response = resp;
      } else {
        throw new Error('Erro ao pegar as informações');
      }
    });
    return response;
  }


  obterAmbiente(): string {
  const host = location.host.toLowerCase();

  if (host.includes('localhost') || host.startsWith('d-')) {
    return 'DESENVOLVIMENTO';
  } else if (host.startsWith('h-')) {
    return 'HOMOLOGACAO-UNIFICADO';
     } else if (host.startsWith('q-')) {
    return 'TESTE';
  } 

  return 'PRODUCAO-UNIFICADO';
}


  Init(): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    this.obterConfigObservable()
      .pipe(
        tap(config => {
          if (config) {
            sessionStorage.setItem('configCRC', JSON.stringify(config));
          }
        })
      )
      .subscribe({
        next: () => resolve(),
        error: err => reject(err)
      });
    });
  }
}